

















































































































import { FormField, FormOption, CommonField } from '@ssp/inscreva-sse-models';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Emit } from 'vue-property-decorator';

import FieldRegistration from './FieldRegistration.vue';
import { Button } from './inscreva-sse/DynamicForm.vue';

@Component({
  components: {
    FieldRegistration,
  },
})
export default class DynamicFieldsFormComponent extends Vue {
  private newField: FormField = null;

  private newFieldOption: FormOption = null;

  public isEditingField: boolean = false;

  $refs!: {
    fieldValidation: InstanceType<typeof ValidationProvider>;
    optionValidation: InstanceType<typeof ValidationProvider>;
  };

  @Emit()
  private onCancelField() {
    // emit onCancelField
  }

  @Emit()
  private onCreateField() {
    // emit onCreateField
  }

  @Emit()
  private onAddField(field: FormField) {
    return field;
  }

  @Emit()
  private onUpdate() {
    // emit onUpdate
  }

  getOptionId(): string {
    if (!this.newField?.options?.length) {
      return `${this.newField.name}_option_0`;
    }
    const lastItem = this.newField.options[this.newField.options.length - 1];
    return `${this.newField.name}_option_${Number(lastItem.id.split('_option_')[1]) + 1}`;
  }

  getButtonIcon(field: CommonField) {
    return field ? 'check' : 'plus';
  }

  get field_button_icon(): string {
    return this.getButtonIcon(this.newField);
  }

  get option_button_icon(): string {
    return this.getButtonIcon(this.newFieldOption);
  }

  get field_has_name(): boolean {
    return !!this.newField.text;
  }

  get field_formatted_name(): string {
    return this.newField.text.toUpperCase();
  }

  get field_type_name(): string {
    return `CAMPO ${
      (this.newField.type &&
        (this.field_has_name ? `"${this.field_formatted_name}"` : this.newField.options ? 'DE SELEÇÃO' : 'SIMPLES')) ||
      ''
    }`;
  }

  get option_has_name(): boolean {
    return !!this.newFieldOption.text;
  }

  get option_formatted_name(): string {
    return this.newFieldOption.text.toUpperCase();
  }

  get option_name(): string {
    return `${this.newFieldOption && (this.option_has_name ? `"${this.option_formatted_name}"` : 'DE SELEÇÃO')}`;
  }

  get is_field_obligatory(): boolean {
    return this.newField?.validations?.includes('required');
  }

  get is_editing_fields(): boolean {
    return !this.newField && !this.newFieldOption;
  }

  create() {
    this.isEditingField = true;
    this.newField = {
      name: '',
      type: null,
      text: '',
    } as FormField;
    return this.onCreateField();
  }

  createField() {
    this.create();
    this.newField.type = 'field';
  }

  async addNewField() {
    if (!(await this.checkFieldValidation())) {
      return;
    }
    const field: FormField = {
      ...this.newField,
      buttons: [
        {
          id: 'delete',
          type: 'danger',
          icon: 'times',
          text: 'remover',
        } as Button,
      ],
    } as FormField;
    this.newField = null;
    this.newFieldOption = null;
    this.isEditingField = false;
    this.onAddField(field);
    this.onUpdate();
  }

  onSelectTypeSimpleField() {
    this.newFieldOption = null;
    this.createField();
  }

  onSelectTypeSelectionField() {
    this.createField();
    this.newField.options = [];
    this.createOption();
  }

  createOption() {
    this.newFieldOption = {
      name: '',
      id: this.getOptionId(),
      value: this.getOptionId(),
      type: 'field', // TODO: quando for recursivo, o tipo deve ser option e deve poder adicionar novos abaixo
      text: '',
    } as FormField;
  }

  async addNewFieldOption() {
    if (!(await this.isValid())) {
      return;
    }
    const option: FormOption = {
      ...this.newFieldOption,
      id: this.getOptionId(),
      value: this.getOptionId(),
      buttons: [
        {
          id: 'delete',
          type: 'danger',
          icon: 'times',
          text: 'remover',
        } as Button,
      ],
    } as FormOption;
    this.newField.options.push(option);
    this.newFieldOption = null;
    setTimeout(() => this.createOption(), 100);
    this.onUpdate();
  }

  deleteFieldOption({ id }: FormField) {
    const optionIndex: number = this.newField.options.findIndex((option) => option.id === id);
    this.newField.options.splice(optionIndex, 1);
    this.onUpdate();
  }

  async checkFieldValidation(): Promise<boolean> {
    return (this.newField && this.syncValueAndValidate(this.newField.text, this.$refs.fieldValidation)) ?? true;
  }

  async checkOptiondValidation(): Promise<boolean> {
    return (
      (this.newFieldOption && this.syncValueAndValidate(this.newFieldOption.text, this.$refs.optionValidation)) ?? true
    );
  }

  async isValid(): Promise<boolean> {
    const fieldValidation = await this.checkFieldValidation();
    const optionValidation = await this.checkOptiondValidation();
    return fieldValidation && optionValidation;
  }

  cancel() {
    this.newField = null;
    this.newFieldOption = null;
    return this.onCancelField();
  }

  async syncValueAndValidate(value: any, validation: InstanceType<typeof ValidationProvider>): Promise<boolean> {
    await validation?.syncValue(value);
    await validation?.validate().then(({ errors }) => validation.setErrors(errors));
    return (await validation?.validate())?.valid;
  }

  onSelectFieldObligatory($event: any) {
    const isObligatory = !!$event.target?.checked;
    const validationsWithoutRequired: string = (this.newField.validations || '').split('required|').join('');
    this.newField.validations = `${isObligatory ? 'required' : ''}${
      (validationsWithoutRequired && `|${validationsWithoutRequired}`) || ''
    }`;
  }
}
